import normalize from 'components/Dashboard/utilities/normalizeString';
import React from 'react';
import ItemNew from 'components/Dashboard/KeyUpdates/ItemNew';
import ConsultationItem from 'components/Dashboard/ConsultationsSection/consultationItem';
import LegislationItem from 'components/Dashboard/Legislation/LegislationItem';
import ParliamentLiveItem from 'components/Dashboard/ParliamentLive/ParliamentLiveItem';
import CommitteePublicationItem from 'components/Dashboard/CommitteePublication/CommitteePublicationItem';
import ParliamentaryItem from 'components/Dashboard/ParliamentaryRecord/ParlamentaryItem';
import LibraryMaterialItem from 'components/Dashboard/LibraryMaterial/LibraryMaterialItem';
import InfluenceItem from 'components/Dashboard/UserContent/ui/InfluenceListItem';
import TweetItem from 'components/Dashboard/SocialMedia/TweetItem';
import { UpcomingEventItem } from 'components/Dashboard/UpcomingEvents/CalendarSearchRenderFunctions';
import StakeholderItem from 'components/Dashboard/StakeHolders/StakeholderItem';
import RegulationDocumentItem from 'components/Dashboard/Regulations/RegulationDocumentItem';
import RegulationCommentItem from 'components/Dashboard/Regulations/RegulationCommentItem';
import { flattenListRowProps } from 'components/Dashboard/ListControl/listRowProps';

const ListItem = ({ sectionName, index, listRow, item, section, keywordListId, embed }) => {
  const key = embed ? `${sectionName}-item-${index}` : `item-${normalize(sectionName)}-${index}`;
  switch (sectionName) {
    case 'KeyUpdates':
    case 'ElectionKeyUpdates':
    case 'HandPickedKeyUpdates':
      return (
        <ItemNew
          key={key}
          listRow={{
            ...listRow,
            display: {
              ...(listRow?.display ?? {}),
              switchRelevantExtractOrSummary: embed ? undefined : true,
            },
          }}
        />
      );
    case 'Consultations':
      return (
        <ConsultationItem
          key={key}
          listRow={{
            ...listRow,
            sectionMeta: {
              ...(listRow?.sectionMeta ?? {}),
              includeTags: embed ? undefined : true,
              isAll: embed ? undefined : !section.totalHits,
            },
          }}
        />
      );
    case 'Legislation':
      return <LegislationItem key={key} listRow={listRow} />;
    case 'ParliamentLive':
      return embed ? (
        <LegislationItem key={key} listRow={listRow} />
      ) : (
        <ParliamentLiveItem key={key} listRow={listRow} />
      );
    case 'RealtimeUtterances':
      return <ParliamentLiveItem key={key} listRow={listRow} />;
    case 'CommitteePublications':
      return (
        <CommitteePublicationItem
          key={key}
          listRow={{
            ...listRow,
            sectionMeta: {
              ...(listRow?.sectionMeta ?? {}),
              numberOfContributions: embed ? undefined : section?.collapsedHits[index]?.totalHits,
            },
          }}
        />
      );
    case 'ParliamentaryRecord':
      return (
        <ParliamentaryItem
          key={key}
          listRow={{
            ...listRow,
            sectionMeta: {
              ...(listRow?.sectionMeta ?? {}),
              numberOfContributions: embed ? undefined : section?.collapsedHits[index]?.totalHits,
            },
          }}
        />
      );
    case 'LibraryMaterial':
    case 'CommonsLibraryArticles':
      return (
        <LibraryMaterialItem
          key={key}
          listRow={
            embed
              ? listRow
              : {
                  ...listRow,
                  feedOverrides: {
                    ...(listRow?.feedOverrides ?? {}),
                    feedItemFlags: section?.feedItemFlags,
                  },
                }
          }
        />
      );
    case 'Influence':
    case 'LobbyingMaterial':
      return (
        <InfluenceItem
          key={key}
          listRow={{
            ...listRow,
            feedOverrides: {
              ...(listRow?.feedOverrides ?? {}),
              feedItemFlags: section?.feedItemFlags,
            },
          }}
        />
      );
    case 'SocialMedia':
    case 'Tweets':
      return (
        <TweetItem
          key={key}
          listRow={{
            ...listRow,
            external: {
              ...(listRow?.external ?? {}),
              itemFromWidget: embed ? !!keywordListId : undefined,
              keywordListId: embed ? keywordListId : undefined,
            },
          }}
        />
      );
    case 'UpcomingEvents':
      return <UpcomingEventItem key={key} {...flattenListRowProps(listRow)} />;
    case 'CustomContacts':
      return <StakeholderItem key={key} listRow={listRow} />;
    case 'Regulations':
      if (item?.type === 'RegulationDocumentComment') {
        return <RegulationCommentItem key={key} listRow={listRow} />;
      }
      return (
        <RegulationDocumentItem
          key={key}
          listRow={{
            ...listRow,
            sectionMeta: {
              ...(listRow?.sectionMeta ?? {}),
              numberOfContributions: embed ? undefined : section?.collapsedHits[index]?.totalHits,
            },
          }}
        />
      );
    default:
      return '';
  }
};

export default ListItem;
